import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import GradeEntryCourse from "../components/SubmittedGradeFormCourse";
import submittedgradesapi from '../api/submittedgrades';
import loginapi from '../api/login';


import { APISERVERURL } from '../APIServerURL';


const MarksEntryForm = ({accessToken,setAccessToken,setRefreshFailed}) => {
  const navigate = useNavigate();
  const { batch,session,courseCode } = useParams();

  const [studentListLoaded,setStudentListLoaded]=useState(false);
  const [courseDetailsLoaded,setCourseDetailsLoaded]=useState(false);
  
  const [marksData, setMarksData] = useState([
  ]);
  const [courseDetails,setCourseDetails]=useState(null);
  const [submissionStatus,setSubmissionStatus]=useState('done');

  const [midTermTotal,setMidTermTotal]=useState(0);
  const [endTermTotal,setEndTermTotal]=useState(0);
  const [practicalTotal,setPracticalTotal]=useState(0);

  const [midTermPass,setMidTermPass]=useState(0);
  const [endTermPass,setEndTermPass]=useState(0);
  const [practicalPass,setPracticalPass]=useState(0);

  
  const handleGoBack = () => {
    navigate(`/submittedgradebatches/${courseCode}/${session}`); 
  };


 const handleAllowGradeChange = async () => {
    const isConfirmed = window.confirm("This action will allow the grades to be edited from the GRADE COMPUTATION page. Are you sure you want to continue?");
    if (isConfirmed) {
      // Proceed with the actual work
      setStudentListLoaded(false);
      setCourseDetailsLoaded(false);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await submittedgradesapi.post('/allowGradeEdit',{batch,session,courseCode},{headers:{'Authorization':`Bearer ${accessToken}`}});  
        await fetchAllFormFillupStudents();
        await fetchBatchSubmissionDetails();
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await submittedgradesapi.post('/allowGradeEdit',{batch,session,courseCode},{headers:{'Authorization':`Bearer ${nat}`}});   
                        await fetchAllFormFillupStudents();
                        await fetchBatchSubmissionDetails();
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              //setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
      
    } else {
      
    }
  };

  const fetchAllFormFillupStudents=async ()=>{
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await submittedgradesapi.post('/getAllFormFillupStudentsOfABatch',{session:session,courseCode:courseCode,batch:batch},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setMarksData(response.data.marksData);setStudentListLoaded(true);
      //alert(JSON.stringify(response.data.marksData));
      }
      catch(err)
      {        
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await submittedgradesapi.post('/getAllFormFillupStudentsOfABatch',{session:session,courseCode:courseCode,batch:batch},{headers:{'Authorization':`Bearer ${nat}`}});   
                      setMarksData(response.data.marksData);setStudentListLoaded(true);
                      //alert(response.data);
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                    {
                      navigate(`/accessdenied`); 
                    }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  }

  const fetchBatchSubmissionDetails=async ()=>{
    try{ 
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await submittedgradesapi.post('/getBatchSubmissionDetails',{session:session,courseCode:courseCode,batch:batch},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setCourseDetails(response.data.courseDetails); 
      setSubmissionStatus(response.data.courseDetails.submissionStatus);

      setMidTermTotal(response.data.courseDetails.midTermTotal);
      setEndTermTotal(response.data.courseDetails.endTermTotal);
      setPracticalTotal(response.data.courseDetails.practicalTotal);

      setMidTermPass(response.data.courseDetails.midTermPass);
      setEndTermPass(response.data.courseDetails.endTermPass);
      setPracticalPass(response.data.courseDetails.practicalPass);

      setCourseDetailsLoaded(true);
      //alert(JSON.stringify(response.data.courseDetails));
      }
      catch(err)
      {
        
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await submittedgradesapi.post('/getBatchSubmissionDetails',{session:session,courseCode:courseCode,batch:batch},{headers:{'Authorization':`Bearer ${nat}`}});   
                      setCourseDetails(response.data.courseDetails);

                      setMidTermTotal(response.data.courseDetails.midTermTotal);
                        setEndTermTotal(response.data.courseDetails.endTermTotal);
                        setPracticalTotal(response.data.courseDetails.practicalTotal);

                        setMidTermPass(response.data.courseDetails.midTermPass);
                        setEndTermPass(response.data.courseDetails.endTermPass);
                        setPracticalPass(response.data.courseDetails.practicalPass);

                      setSubmissionStatus(response.data.courseDetails.submissionStatus); 

                      setCourseDetailsLoaded(true);
                      //alert(response.data);
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  }

useEffect(()=>{
   
  fetchAllFormFillupStudents();
  },[]);
  
useEffect(()=>{
   
  fetchBatchSubmissionDetails();
  },[]); 
  


  function downloadFile(fname)
    {
      fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
        response.blob().then((blob) => {
         
            // Creating new object of PDF file
            const fileURL =
                window.URL.createObjectURL(blob);
                 
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = fname;
            alink.click();
            //setIsloading(false);
        });
      });
    }

async function handleDownloadCSV(e)
    {
      e.preventDefault();
      try{
        const response= await submittedgradesapi.post('/getGradeEntryCSV',{ batch,session,courseCode},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        alert(response.data);
        downloadFile(response.data);
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          try{       
            const response= await submittedgradesapi.post('/getGradeEntryCSV',{ batch,session,courseCode},{headers:{'Authorization':`Bearer ${nat}`}});    
            downloadFile(response.data);
           }
           catch(err)
           {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            alert('unusual error newposts.js');
           }
        }
        catch(err)
        {
          alert('failed');
        }

      }
    }



  return (
    <main className="w-full">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center">SUBMITTED GRADE FORM</h1>
            <p className="w-full text-center  text-xs">(...)</p>    
          </div>

        

    


    {studentListLoaded && courseDetailsLoaded && <div className="w-[98%] max-w-[1200px] mt-4">
        <div className="w-full font-semibold border-b text-center">
            <p>{courseDetails?courseDetails.title:''}</p>
            <button 
              className="underline text-blue-600 hover:text-blue-800 cursor-pointer text-xs"
              onClick={handleDownloadCSV}
            >
              DOWNLOAD CSV
            </button>
        </div>
        <div className="w-full border-b  grid grid-cols-[2fr_.5fr_1.5fr_1.5fr_1.5fr] gap-md-4 p-1 text-center ">
            <div className="bg-red-100 p-3">
                <div >
                    <p className="text-gray-700  font-small text-xs">CODE</p>
                    <p className="text-gray-900 font-medium text-sm">  {courseDetails?courseDetails.code:''}</p>
                </div>
            </div>

            <div className="bg-red-100 p-3">
                <div>
                    <p className="text-gray-700  font-small text-xs">Cr.</p>
                    <p className="text-gray-900 font-medium text-sm">  {courseDetails?courseDetails.credit:''}</p>
                </div>
            </div>

            
            <div className="text-center flex-col bg-red-100">
                <div>
                    <p className="text-xs text-gray-500 border-b border-gray-300">INTERNAL</p>
                </div>
                <div className="flex">
                        <div className="flex flex-col flex-1 m-2">
                            <p className="text-gray-500  font-small text-xs">TOTAL</p> 
                            <input
                                type="number"
                                className="w-full bg-transparent text-gray-900 font-medium text-sm font-semibold border-b-2 border-blue-500 focus:border-green-500 outline-none p-1 text-center"
                                value={midTermTotal||0}  disabled={submissionStatus!=='marksentry'}
                                />
                        </div>
                    <div className="flex flex-col flex-1  m-2">
                            <p className="text-gray-500  font-small text-xs">PASS</p> 
                            <input
                                type="number"
                                className="w-full bg-transparent text-gray-900 font-medium text-sm font-semibold border-b-2 border-blue-500 focus:border-green-500 outline-none p-1 text-center"
                                value={midTermPass||0} disabled={submissionStatus!=='marksentry'}
                                />
                    </div>
              </div>
            </div>

            <div className="text-center flex-col bg-red-100">
                <div>
                    <p className="text-xs text-gray-500 border-b border-gray-300">PRACTICAL</p>
                </div>
                <div className="flex">
                        <div className="flex flex-col flex-1 m-2">
                            <p className="text-gray-500  font-small text-xs">TOTAL</p> 
                            <input
                                type="number"
                                className="w-full bg-transparent text-gray-900 font-medium text-sm font-semibold border-b-2 border-blue-500 focus:border-green-500 outline-none p-1 text-center"
                                value={practicalTotal||0} disabled={submissionStatus!=='marksentry'}
                                />
                        </div>
                    <div className="flex flex-col flex-1  m-2">
                            <p className="text-gray-500  font-small text-xs">PASS</p> 
                            <input
                                type="number"
                                className="w-full bg-transparent text-gray-900 font-medium text-sm font-semibold border-b-2 border-blue-500 focus:border-green-500 outline-none p-1 text-center"
                                value={practicalPass||0} disabled={submissionStatus!=='marksentry'}
                                />
                    </div>
              </div>
            </div>

            <div className="text-center flex-col bg-red-100">
                <div>
                    <p className="text-xs text-gray-500 border-b border-gray-300">THEORY</p>
                </div>
                <div className="flex">
                        <div className="flex flex-col flex-1 m-2">
                            <p className="text-gray-500  font-small text-xs">TOTAL</p> 
                            <input
                                type="number"
                                className="w-full bg-transparent text-gray-900 font-medium text-sm font-semibold border-b-2 border-blue-500 focus:border-green-500 outline-none p-1 text-center"
                                value={endTermTotal||0} disabled={submissionStatus!=='marksentry'}
                                />
                        </div>
                    <div className="flex flex-col flex-1  m-2">
                            <p className="text-gray-500  font-small text-xs">PASS</p> 
                            <input
                                type="number"
                                className="w-full bg-transparent text-gray-900 font-medium text-sm font-semibold border-b-2 border-blue-500 focus:border-green-500 outline-none p-1 text-center"
                                value={endTermPass||0} disabled={submissionStatus!=='marksentry'}
                                />
                    </div>
              </div>
            </div>
           
        </div>

        <div className="w-full border bg-gray-100 grid grid-cols-[1fr_2fr_4fr_1fr_1fr_1fr_1fr_1fr_1.5fr] gap-1 p-1 mt-2 text-xs">
               <div  className="w-full text-center">
                SN
               </div>
               <div  className="w-full text-center">
                RLNO
               </div>
               <div  className="w-full text-center">
                NAME
               </div>
               <div  className="w-full text-center">
                INT
               </div>
               <div  className="w-full text-center">
                PRC
               </div>
               <div  className="w-full text-center">
                THR
               </div>
               <div  className="w-full text-center">
                GTTL
               </div>
               <div  className="w-full text-center">
                %
               </div>
               <div  className="w-full text-center">
                GRADE
               </div>
        </div>
        {marksData.map((student, index) => (
          <GradeEntryCourse
            key={student.rollno}
            student={student}
            index={index}
            state={submissionStatus}// {courseDetails?courseDetails.submissionStatus?courseDetails.submissionStatus:'done':'done'}
            mt={midTermTotal}
            pt={practicalTotal}
            et={endTermTotal}
          />
        ))}

<div className="w-full flex justify-between p-2 mt-2 mb-2 flex flex-wrap ">
      
      {submissionStatus === "done" ? (
        <>
          <div className="flex">
          <button 
            onClick={handleAllowGradeChange} 
            className="ml-2 mt-2 bg-pink-400 text-white py-2 px-4 rounded hover:bg-gray-700 text-xs"
          >
            ALLOW GRADE CHANGE
          </button>
        </div></>
      ) :submissionStatus === "gradecomputation" ? (
        <button 
          disabled 
          className="ml-2 mt-2 bg-gray-300 text-gray-600 py-2 px-4 rounded text-xs cursor-not-allowed"
        >
          GRADES NOT SUBMITTED
        </button>
      ):(<button 
        disabled 
        className="ml-2 mt-2 bg-gray-300 text-gray-600 py-2 px-4 rounded text-xs cursor-not-allowed"
      >
        MARKS NOT SUBMITTED
      </button>)}     
    </div>

    </div>
   }
   {
   (!studentListLoaded || !courseDetailsLoaded) && <div className="w-[98%] max-w-[1200px]">
    Please wait!
    </div>
    }
    </div>
    </main>
  );
};

export default MarksEntryForm;
